(($) => {
	// ========================================================
	// GLOBALS
	// ========================================================

	const Globals = {
		// Variables
		$body: $("body"),
		$window: $(window),
		$document: $(document),
		// Methods
		addMobileDetection: function () {
			// @link https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
			if (
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
			) {
				this.$body.addClass("is-mobile");
			}
		},
		add: function (key, val) {
			this[key] = val;
		},
	};

	Globals.addMobileDetection();

	Globals.add("sliders", {
		nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none"><g opacity=".5"><rect width="30" height="30" x="-1" y="1" stroke="#354044" stroke-width="2" rx="15" transform="matrix(-1 0 0 1 30 .059)"/><path fill="#354044" d="m21.532 16.026-1.543-1.414-7.713 7.07 1.542 1.415z"/><path fill="#354044" d="m19.99 17.44 1.542-1.414-7.713-7.07-1.543 1.414z"/></g></svg></button>`,
		prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none"><g opacity=".5"><rect width="30" height="30" x="1" y="1.059" stroke="#354044" stroke-width="2" rx="15"/><path fill="#354044" d="m10.468 16.026 1.543-1.414 7.713 7.07-1.542 1.415z"/><path fill="#354044" d="m12.01 17.44-1.542-1.414 7.713-7.07 1.543 1.414z"/></g></svg></button>`,
	});

	/**
	 * Gulp include scripts
	 *
	 * @link https://www.npmjs.com/package/gulp-include
	 */
	/**
	 * CallTracker module for managing call tracking phone numbers based on source data.
	 * Looks for a phone number called a "swap" number on the page and then dynamically replaces it with the call tracking number.
	 * The appropriate call tracking number is determined based on the source data provided by the SourceTracker library.
	 *
	 * Requires SourceTracker library to be loaded on the page.
	 * - Should wait for 'trmk:source-tracker-initialized' event before initializing.
	 *
	 * example usage:
	 * jQuery(document).on('trmk:source-tracker-initialized', () => {
			TrimarkCallTracker.init({
				swap: '',
				default: '',
				triggers: {
					utm_source: {
						google: '555-1234',
						bing: '555-5678',
					},
					src: {
						google: '555-1234',
						bing: '555-5678',
					},
			});
			TrimarkCallTracker.updatePhones();
		});
	 *
	 * @returns {object} CallTracker
	 */
	const CallTracker = () => {
		const module = {
			/**
			 * Settings for the CallTracker library.
			 */
			settings: {},
			/**
			 * Initializes the CallTracker library.
			 *
			 * @param {object} settings
			 * @returns void
			 */
			init: function(settings) {
				if (typeof TrimarkSourceTracker === 'undefined') {
					console.warn('TrimarkSourceTracker is not initialized. CallTracker cannot function without it.');
					return;
				}
	
				this.settings = settings;
				this.updatePhones();
			},
			/**
			 * Gets the call tracking phone number based on the source data.
			 *
			 * @returns {string} The phone number to be used for call tracking.
			 */
			getCallTrackingPhone: function() {
				const sourceCookie = TrimarkSourceTracker.getSourceData();
				const {triggers} = this.settings;
				let targetPhone = '';
	
				// Loop through triggers
				// - 1st trigger that matches the source cookie will be used
				for (const trigger of Object.keys(triggers)) {
					if (sourceCookie.hasOwnProperty(trigger)) {
						Object.keys(triggers[trigger]).forEach(key => {
							if (key === sourceCookie[trigger]) {
								targetPhone = triggers[trigger][key].phone;
							}
						});
						break;
					}
				};
	
				return targetPhone;
			},
			/**
			 * Updates phone numbers in anchor tags that contain the specified swap number.
			 * @returns void
			 */
			updatePhones: function() {
				let phone = this.getCallTrackingPhone();
	
				// If user is a paid user, use the default phone number if no tracking number is found
				if (Cookies.get('trmk_is_paid') && phone === '') {
					phone = this.settings.default;
				}
	
				// If no phone number is found, do not update anything
				if (phone === '') {
					return;
				}
	
				$(`a:contains(${this.settings.swap})`).each((i, el) => {
					const $html = $(el).html();
					const newHtml = $html.replace(this.settings.swap, phone);
	
					// Update the href attribute to use the call tracking number
					$(el).attr('href', `tel:${phone.replace(/\D/g, '')}`);
					// Update the visible text to use the call tracking number
					$(el).html(newHtml);
				});
			},
		}
	
		return module;
	}
	
	/**
	 * Jquery document ready.
	 * Initialize CallTracker library globally so it can abe initalized from anywhere.
	 */
	window.TrimarkCallTracker = new CallTracker();
	
		/**
	 * Exit Popup Chatbot
	 *
	 * Wires up an embedded chatbot inside the #exit-intent-popup modal.
	 * Reuses the WWChatConfig global set by the main chat widget enqueue.
	 *
	 * NOTE: WWChatConfig is injected by an inline script attached to the chat
	 * widget (priority 120), which loads AFTER scripts.js. All config access
	 * is therefore deferred until the popup is actually shown via Fancybox.
	 */
	(function ($) {
		'use strict';
	
		var initialized = false;
		var DEFAULT_RESPONSE_ICON_SRC = '/wp-content/themes/breeze/dist/images/response.png';
	
		// Listen for the exit popup opening via Fancybox
		$(document).on('afterShow.fb', function (_e, instance, slide) {
			var src = (slide && slide.src) || '';
			if (src !== '#exit-intent-popup') return;
			if (initialized) return;
	
			var popup = document.getElementById('exit-intent-popup');
			if (!popup || !popup.classList.contains('exit-popup-chatbot')) return;
	
			var config = window.WWChatConfig;
			if (!config || !config.api || !config.api.url) return;
	
			initialized = true;
			init(popup, config);
		});
	
		function init(popup, config) {
			var messagesContainer = popup.querySelector('.exit-chatbot__messages');
			var textarea = popup.querySelector('.exit-chatbot__input textarea');
			var sendButton = popup.querySelector('.exit-chatbot__input button');
			var closeButton = popup.querySelector('.exit-chatbot__close');
			var header = popup.querySelector('.exit-chatbot__header');
			var launcherIcon = ((config.branding && config.branding.launcher) || '').trim();
			var responseIconSrc = launcherIcon || popup.getAttribute('data-response-icon') || DEFAULT_RESPONSE_ICON_SRC;
			if (!messagesContainer || !textarea || !sendButton) return;
	
			var STORAGE_KEY = 'ww_exit_chat_' + config.api.franchiseId;
			var sessionId = 'exit-' + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substr(2));
	
			// Try to restore session
			try {
				var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
				if (saved && saved.sessionId && (Date.now() - saved.timestamp) < 24 * 60 * 60 * 1000) {
					sessionId = saved.sessionId;
				} else {
					localStorage.removeItem(STORAGE_KEY);
				}
			} catch (e) {}
	
			function saveSession() {
				try {
					localStorage.setItem(STORAGE_KEY, JSON.stringify({
						sessionId: sessionId,
						timestamp: Date.now()
					}));
				} catch (e) {}
			}
	
			function parseMarkdown(text) {
				return text
					.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" loading="lazy">')
					.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
					.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
					.replace(/\n/g, '<br>');
			}
	
			function createAvatar() {
				var avatar = document.createElement('div');
				avatar.className = 'exit-chatbot__avatar exit-chatbot__avatar--image';
				var img = document.createElement('img');
				img.src = responseIconSrc;
				img.alt = '';
				img.loading = 'lazy';
				img.setAttribute('aria-hidden', 'true');
				avatar.appendChild(img);
				return avatar;
			}
	
			function addMessage(text, isUser) {
				var row = document.createElement('div');
				row.className = 'exit-chatbot__row ' + (isUser ? 'exit-chatbot__row--user' : 'exit-chatbot__row--bot');
	
				if (!isUser) {
					row.appendChild(createAvatar());
				}
	
				var el = document.createElement('div');
				el.className = 'exit-chatbot__message ' + (isUser ? 'exit-chatbot__message--user' : 'exit-chatbot__message--bot');
				el.innerHTML = isUser ? text : parseMarkdown(text);
				row.appendChild(el);
	
				messagesContainer.appendChild(row);
				messagesContainer.scrollTop = messagesContainer.scrollHeight;
				return row;
			}
	
			function showTyping() {
				var row = document.createElement('div');
				row.className = 'exit-chatbot__row exit-chatbot__row--bot';
	
				row.appendChild(createAvatar());
	
				var el = document.createElement('div');
				el.className = 'exit-chatbot__typing';
				el.innerHTML = '<span></span><span></span><span></span>';
				row.appendChild(el);
	
				messagesContainer.appendChild(row);
				messagesContainer.scrollTop = messagesContainer.scrollHeight;
				return row;
			}
	
			function sendMessage(message) {
				addMessage(message, true);
				textarea.disabled = true;
				sendButton.disabled = true;
	
				var typingRow = showTyping();
	
				fetch(config.api.url + '/chat/' + config.api.franchiseId, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-API-Key': config.api.apiKey || ''
					},
					body: JSON.stringify({
						message: message,
						session_id: sessionId,
						mode: 'default'
					})
				})
				.then(function (response) { return response.json(); })
				.then(function (data) {
					typingRow.remove();
					addMessage(data.response, false);
					saveSession();
				})
				.catch(function () {
					typingRow.remove();
					addMessage('Sorry, there was an error. Please try again.', false);
				})
				.finally(function () {
					textarea.disabled = false;
					sendButton.disabled = false;
					textarea.focus();
					});
			}
	
			function playIntroSequence() {
				if (!header || header.dataset.introPlayed === 'true') return;
	
				setTimeout(function () {
					header.classList.add('is-intro-typing');
				}, 250);
	
				setTimeout(function () {
					header.classList.remove('is-intro-typing');
					header.classList.add('is-intro-ready');
					header.dataset.introPlayed = 'true';
				}, 1250);
			}
	
			playIntroSequence();
	
			// Send button
			sendButton.addEventListener('click', function () {
				var msg = textarea.value.trim();
				if (msg) {
					sendMessage(msg);
					textarea.value = '';
				}
			});
	
			// Enter to send
			textarea.addEventListener('keypress', function (e) {
				if (e.key === 'Enter' && !e.shiftKey) {
					e.preventDefault();
					var msg = textarea.value.trim();
					if (msg) {
						sendMessage(msg);
						textarea.value = '';
					}
				}
			});
	
			if (closeButton) {
				closeButton.addEventListener('click', function (e) {
					e.preventDefault();
					if ($.fancybox && $.fancybox.getInstance()) {
						$.fancybox.close(true);
					}
				});
			}
		}
	})(jQuery);
	
		// Minimum delay from Chatbot options (launcher_prompt_delay_seconds).
	// Shared gate so neither desktop nor mobile exit-intent fires before it elapses.
	(function () {
		const startTs = Date.now();
		window.__exitPopupReadyToShow = function () {
			let seconds = 0;
			try {
				seconds = Number(window.WWChatConfig.behavior.launcherPromptDelaySeconds) || 0;
			} catch (e) {}
			return (Date.now() - startTs) >= Math.max(0, seconds) * 1000;
		};
	})();
	
	(function ($) {
		// ===== Helpers (shared) =====
		const MM = window.matchMedia("(max-width: 767.98px)");
		const isMobile = () => MM.matches;
		const isThankYouView = () => {
			const params = new URLSearchParams(window.location.search);
			const thankYouParam = (params.get("thank_you") || "").toLowerCase();
			return (
				thankYouParam === "true" ||
				/(\/|^)(thank-?you|in-home-estimate-survey)(\/|$)/i.test(location.pathname)
			);
		};
	
		if (isThankYouView()) {
			return;
		}
	
		const getInlineTarget = ($el) => {
			const t = ($el.data("src") || $el.attr("href") || "").trim();
			return t && t.charAt(0) === "#" ? t : null;
		};
		const wantsStep2 = ($el) => String($el.data("step")) === "2";
		const activateStep2 = () => $("#popupForm").addClass("step-2-active");
		const resetStep = () => $("#popupForm").removeClass("step-2-active");
	
		// Fancybox sane defaults (one-at-a-time, no weird refocus)
		if ($.fancybox?.defaults) {
			$.fancybox.defaults.closeExisting = true;
			$.fancybox.defaults.backFocus = false;
			$.fancybox.defaults.autoFocus = false;
			$.fancybox.defaults.trapFocus = true;
		}
	
		// ===== Global bindings (don’t rebind inside show()) =====
		// Inline button to jump to step 2 (mobile only)
		$(document).on("click", ".step-2-trigger", function (e) {
			if (isMobile()) {
				e.preventDefault();
				activateStep2();
			}
		});
	
		// Reset ONLY when #popupForm actually closes
		$(document).on(
			"beforeClose.fb afterClose.fb",
			function (_e, instance, slide) {
				const src =
					(slide && slide.src) ||
					(instance && instance.current && instance.current.src) ||
					"";
				if (src === "#popupForm") resetStep();
			}
		);
	
		// ===== Exit Intent Controller =====
		const ExitPopup = {
			shown: false,
	
			init() {
				if ($("#exit-intent-popup").length) this.bindExitIntent();
				window.__showExit = () => this.show(); // manual test
			},
	
			isLtoPopupOpen() {
				return document.body.classList.contains("lto-popup-open");
			},
	
			bindExitIntent() {
				if (sessionStorage.getItem('exit_popup') === 'closed') return;
				$(document).on("mouseout.exitIntent", (e) => {
					if (this.shown) return;
					const leftDoc = !e.relatedTarget && !e.toElement;
					const topEdge = e.clientY <= 0;
					if (leftDoc && topEdge) {
						const didShow = this.show();
						// Only unbind if popup was actually shown
						if (didShow) {
							$(document).off("mouseout.exitIntent");
						}
					}
				});
			},
	
			show() {
				// Don't show if LTO popup is currently open
				if (this.isLtoPopupOpen()) return false;
				// Respect Chatbot options' launcher_prompt_delay_seconds as a minimum time-on-page
				if (!window.__exitPopupReadyToShow()) return false;
	
				this.shown = true;
	
				$.fancybox.open({
					src: "#exit-intent-popup",
					type: "inline",
					opts: {
						smallBtn: true,
						touch: false,
						trapFocus: true,
						autoFocus: false,
	
						afterShow() {
							$("#exit-intent-popup")
								.off("click.exitPopup")
								.on(
									"click.exitPopup",
									"a, [data-src]",
									function (e) {
										const $el = $(this);
										const target = getInlineTarget($el);
	
										if (!target) {
											$.fancybox.close(true);
											return;
										}
	
										e.preventDefault();
	
										if (target === "#popupForm") {
											if (isMobile() && wantsStep2($el))
												activateStep2();
											else resetStep();
										}
	
										// Close EXIT immediately, then open the target fresh
										$.fancybox.close(true);
										setTimeout(() => {
											$.fancybox.open({
												src: target,
												type: "inline",
												opts: {
													closeExisting: true,
													backFocus: false,
													autoFocus: false,
													trapFocus: true,
	
													// Re-assert AFTER #popupForm renders (belt-and-suspenders)
													afterShow(inst, slide) {
														if (
															slide &&
															slide.src ===
																"#popupForm" &&
															isMobile() &&
															wantsStep2($el)
														) {
															activateStep2();
														}
													},
												},
											});
										}, 0);
									}
								);
						},
	
						afterClose() {
							$("#exit-intent-popup").off("click.exitPopup");
							sessionStorage.setItem("exit_popup", "closed");
						},
					},
				});
	
				return true;
			},
		};
	
		$(ExitPopup.init.bind(ExitPopup));
	})(jQuery);
	
	/* ===== DROP-IN: Mobile exit-intent (scroll-up + safe fallback) =====
	   - Trigger the existing exit popup on touch devices (phones/tablets)
	   - Fire once when user scrolls down >200px then back up near top (<100px)
	   - As a backup, fire after 20s ONLY if there’s some engagement (scrolled ≥300px or typed in a GF form)
	   - Suppress while the user is actively typing in a page form (GF outside the popup)
	   - Respect your existing session guard if you set sessionStorage["exit_popup"] = "closed" elsewhere
	*/
	(function ($) {
	  const IS_TOUCH = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
	  if (!IS_TOUCH) return;
	  const params = new URLSearchParams(window.location.search);
	  const isThankYouView =
	    (params.get("thank_you") || "").toLowerCase() === "true" ||
	    /(\/|^)(thank-?you|thanks|in-home-estimate-survey)(\/|$)/i.test(location.pathname);
	  if (isThankYouView) return;
	
	  const $popup = $("#exit-intent-popup");
	  if (!$popup.length) return;
	  if ($popup.data("popup-enabled") === false) return;
	
	  // ===== Config =====
	  const INACTIVITY_MS = 6000; // if user interacted in last N ms, suppress
	  const SCROLL_DOWN_PX = 200; // "went down"
	  const SCROLL_UP_TOP_PX = 100; // back near top
	  const FALLBACK_MS = 20000; // backup timer
	
	  // ===== State =====
	  let shown = false;
	  let scrolledDown = false;
	  let lastInteractionTs = 0;
	  let fallbackTimer = null;
	
	  const now = () => Date.now();
	  const eligibleSession = () => sessionStorage.getItem("exit_popup") !== "closed";
	  const markInteraction = () => { lastInteractionTs = now(); };
	  const recentlyEngaged = () => (now() - lastInteractionTs) < INACTIVITY_MS;
	
	  // Primary (page) forms = GF wrappers NOT inside the popup
	  const $primaryForms = $(".gform_wrapper").filter(function () {
	    return $(this).closest("#exit-intent-popup").length === 0;
	  });
	
	  if ($primaryForms.length) {
	    $primaryForms.on("input change focusin", "input, select, textarea", markInteraction);
	  }
	
	  // Clicking/touching outside forms ends “recent engagement” immediately
	  $(document).on("mousedown touchstart", function (e) {
	    if (!$(e.target).closest(".gform_wrapper").length) {
	      lastInteractionTs = 0;
	    }
	  });
	
	  // If a GF form submits or shows its confirmation, consider popup done for this session
	  $(document).on("submit", ".gform_wrapper form", () => sessionStorage.setItem("exit_popup", "closed"));
	  $(document).on("gform_confirmation_loaded", () => sessionStorage.setItem("exit_popup", "closed"));
	
	  function shouldSuppress() {
	    if (recentlyEngaged()) return true;
	    const active = document.activeElement;
	    const focusedInForm = active && $(active).closest(".gform_wrapper").filter(function () {
	      return $(this).closest("#exit-intent-popup").length === 0;
	    }).length > 0;
	    return !!focusedInForm;
	  }
	
	  function showOnce(reason) {
	    if (shown) return;
	    if (!eligibleSession()) return;
	    if (shouldSuppress()) return;
	    // Don't show if LTO popup is currently open
	    if (document.body.classList.contains("lto-popup-open")) return;
	    // Respect Chatbot options' launcher_prompt_delay_seconds as a minimum time-on-page
	    if (typeof window.__exitPopupReadyToShow === "function" && !window.__exitPopupReadyToShow()) return;
	
	    shown = true;
	
	    // Prefer your existing hook if present (set in your script): window.__showExit()
	    if (typeof window.__showExit === "function") {
	      window.__showExit();
	    } else {
	      // Minimal fallback (kept consistent with your Fancybox usage)
	      $.fancybox.open({
	        src: "#exit-intent-popup",
	        type: "inline",
	        opts: {
	          smallBtn: true,
	          touch: false,
	          trapFocus: true,
	          autoFocus: false,
	          afterClose() {
	            sessionStorage.setItem("exit_popup", "closed");
	          },
	        },
	      });
	    }
	
	    // Cleanup listeners/timer
	    $(window).off("scroll.exitpopup");
	    if (fallbackTimer) clearTimeout(fallbackTimer);
	  }
	
	  // Trigger A: scroll-down then back up near top (low-noise, intent-ish)
	  $(window).on("scroll.exitpopup", function () {
	    if (shown) return;
	    const y = window.scrollY || window.pageYOffset || 0;
	    if (!scrolledDown && y > SCROLL_DOWN_PX) scrolledDown = true;
	    if (scrolledDown && y < SCROLL_UP_TOP_PX) showOnce("scroll-up-near-top");
	  });
	
	  // Trigger B: fallback after 20s, but only if there’s some engagement
	  fallbackTimer = setTimeout(function () {
	    if (shown) return;
	    const y = window.scrollY || 0;
	    const engaged = y >= 300 || scrolledDown || recentlyEngaged();
	    if (engaged) showOnce("fallback-timer");
	  }, FALLBACK_MS);
	})(jQuery);
	
		// ========================================================
	// FANCYBOX 3.5
	// @link https://obu.edu/_resources/ldp/galleries/fancybox/#options
	// ========================================================
	
	/**
	 * Full screen popup.
	 * Make sure to call inside a jQuery ready function to ensure the DOM is fully loaded.
	 */
	$(() => {
		$('a[href="#popupForm"]').fancybox({
			baseClass: 'fancybox-fullscreen-popup-form',
			touch: false,
			autoFocus: false,
		});
	});
	
	
	/**
	 * Fancybox Custom Close Button
	 */
	const fancyBoxCloseBtnTemplate = `
	<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small">
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g opacity="0.6">
				<path d="M6 17.2269L17.3137 5.91322" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 11.9688H12.0001" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M6 5.9762L17.3137 17.2899" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
			</g>
		</svg>
	</button>`;
	
	$.fancybox.defaults.btnTpl.smallBtn = fancyBoxCloseBtnTemplate;
	$.fancybox.defaults.btnTpl.close = fancyBoxCloseBtnTemplate;
	
		/**
	 * Gravity forms floating labels.
	 */
	$(document).on('gform_post_render', function(event, form_id, current_page){
		const activeClass = 'is-active';
		const wrapperSelector = '.gfield, .gform-grid-col';
		const $selectors = $('.js-gform input[type=text], .js-gform input[type=tel], .js-gform input[type=email], .js-gform input[type=number], .js-gform textarea');
	
		// Inline label forms: Add active class if input has value
		$selectors.each(function () {
			if ($(this).val().length) {
				$(this).closest(wrapperSelector).addClass(activeClass);
			}
		});
	
		$('.js-gform select').on('change', function() {
			if ($(this).val() === "") {
				$(this).closest('.gfield').removeClass(activeClass);
			} else {
				$(this).closest(wrapperSelector).addClass(activeClass);
			}
		});
	
		// Inline label forms: Add active class on focus
		$selectors.on('focus', function () {
			$(this).closest(wrapperSelector).addClass(activeClass);
		});
	
		// Inline label forms: Remove active class on blur
		$selectors.on('blur', function () {
			if (!$(this).val().length || $(this).val().includes('_')) {
				$(this).closest(wrapperSelector).removeClass(activeClass);
			}
		});
	});
	
		(() => {
		const OFFSET = 120;
	
		const findTarget = (id) => {
			if (!id) return null;
			const escapeId = window.CSS && CSS.escape ? CSS.escape(id) : id.replace(/["\\]/g, "\\$&");
			return document.getElementById(id) || document.querySelector(`[name="${escapeId}"]`);
		};
	
		const scrollToId = (id) => {
			const target = findTarget(id);
			if (!target) return;
	
			const doScroll = () => {
				const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
				window.scrollTo({ top, behavior: "auto" });
			};
	
			// Scroll once, then twice more after layout-shift triggers (sticky nav activating,
			// images loading, etc.) settle, so the final position always matches OFFSET.
			doScroll();
			requestAnimationFrame(() => requestAnimationFrame(doScroll));
			setTimeout(doScroll, 200);
		};
	
		document.addEventListener("click", (e) => {
			const link = e.target.closest('a[href*="#"]');
			if (!link) return;
			const url = new URL(link.href, location.href);
			if (url.pathname !== location.pathname || url.host !== location.host) return;
			if (!url.hash || url.hash === "#") return;
			const id = url.hash.slice(1);
			if (!findTarget(id)) return;
	
			e.preventDefault();
			history.pushState(null, "", url.hash);
			scrollToId(id);
		});
	
		const runInitial = () => {
			if (location.hash) scrollToId(location.hash.slice(1));
		};
		if (document.readyState === "complete") {
			setTimeout(runInitial, 0);
		} else {
			window.addEventListener("load", () => setTimeout(runInitial, 0));
		}
	})();
	
		$(() => {
		/**
		 * Navbar superfish mega menu
		 */
		$(".navbar__menu").superfish({
			hoverClass: "sf-hover",
			popUpSelector: ".megamenu, .submenu",
			delay: 300,
			animationOut: { opacity: "hide" },
			speedOut: 0,
		});
	
		$(".navbar__toggler").on("click", (e) => {
			const $toggler = $(e.currentTarget);
			$toggler.attr(
				"aria-expanded",
				() => $toggler.attr("aria-expanded") === "false"
			);
			$(".navbar__menu-slot").toggleClass("navbar__menu-slot--show");
		});
	
		// Trigger child and grandchild page flyouts
		$("li.menu-item").on("click", (e) => {
			$(e.currentTarget).addClass("is-active");
		});
	
		// Prevent clicks on actual menu links from triggering panel flyouts
		$("li.menu-item > a").on("click", (e) => {
			e.stopPropagation();
			e.stopImmediatePropagation();
		});
	
		// Trigger menu "back" functionality
		$(".submenu-back-btn").on("click", (e) => {
			e.stopPropagation();
			$(e.currentTarget).closest(".is-active").removeClass("is-active");
		});
	
		$(".mobile-menu-toggle").click(function () {
			let item = $(this).closest("li");
	
			if (item.hasClass("active")) {
				item.removeClass("active");
			} else {
				item.siblings().removeClass("active");
				item.addClass("active");
			}
		});
	
		const $menuRoot = $(".navbar__menu");
		const SUPERFISH_DELAY = 300;
	
		function swapMenuImage($menu, newSrc) {
			const $img = $menu.find(".megamenu__image > a img").first();
			if (!$img.length) return;
	
			// remember the original src
			if (!$img.data("originalImg")) {
				var origSrc = $img.attr("src") || "";
				var origSet = $img.attr("srcset") || "";
				var origSizes = $img.attr("sizes") || "";
				$img.data("origSrc", origSrc);
				$img.data("origSet", origSet);
				$img.data("origSizes", origSizes);
				$img.data("originalImg", true);
			}
	
			if (newSrc && newSrc.length) {
				// show product_hover_image
				$img.attr("src", newSrc);
				$img.removeAttr("srcset");
				$img.removeAttr("sizes");
			} else {
				// go back to the original
				var set = $img.data("origSet") || "";
				var sizes = $img.data("origSizes") || "";
				$img.attr("src", $img.data("origSrc") || "");
				if (set.length) {
					$img.attr("srcset", set);
				} else {
					$img.removeAttr("srcset");
				}
				if (sizes.length) {
					$img.attr("sizes", sizes);
				} else {
					$img.removeAttr("sizes");
				}
			}
		}
	
		// when a submenu item is hovered, swap to its data-hover-src
		$menuRoot.on("mouseenter", ".megamenu .submenu-link", function () {
			var $link = $(this);
			var src = $link.attr("data-hover-src") || "";
			var $menu = $link.closest(".megamenu");
			if (src.length) {
				swapMenuImage($menu, src);
			} else {
				swapMenuImage($menu, null);
			}
		});
	
		// after the megamenu closes, restore original megamenu__img
		$menuRoot.on("mouseleave", "li.menu-item", function () {
			var $menu = $(this).children(".megamenu").first();
			if (!$menu.length) return;
			setTimeout(function () {
				if (!$menu.is(":visible")) {
					swapMenuImage($menu, null);
				}
			}, SUPERFISH_DELAY + 30);
		});
	});
	
		/**
	 * Source Tracker Library.
	 *
	 * Saves UTM parameters and other URL parameters as well as referrer and landing page URL.
	 * Stores parameters as first-touch and last-touch cookies.
	 * Populates form fields with source data based on specified strategy.
	 * Depending on the strategy, it will either prefill form fields with first-touch or last-touch data.
	 *
	 * Requires js-cookie library to be loaded on the page.
	 *
	 * example usage:
	 * const st = new SourceTracker({
			strategy: 'ft', // "ft" or "lt" (first-touch or last-touch)
			cookie: {
				name: {
					ft: 'trmk_src_first', // cookie name : first touch attribution
					lt: 'trmk_src_last', // cookie name : last touch attribution
				},
				opts: {
					expires: 1, // 1 day
					path: '/' // full site
				}
			},
			forms: {
				prefillAttr: 'data-prefill', // the data attribute of form field to prefill
			},
		})
	 *
	 * @param {object} settings
	 * @returns SourceTracker
	 */
	const SourceTracker = settings => {
		const module = {
			/**
			 * Settings for the SourceTracker library.
			 *
			 * @var {object}
			 */
			settings,
			/**
			 * Flag to check if the SourceTracker library has been initialized.
			 *
			 * @var {boolean}
			 */
			hasInit: false,
			/**
			 * Initialize the SourceTracker library.
			 *
			 * @returns void
			 */
			init: function() {
				// Check if already initialized
				if (this.hasInit) {
					console.warn('SourceTracker has already been initialized.');
					return;
				}
	
				// Check if js-cookie library is loaded
				if (typeof Cookies === 'undefined') {
					console.warn('Please install js-cookie library to enable the SourceTracker library.');
					return;
				}
	
				// Init and set source cookies
				this.hasInit = true;
				this.setSourceCookies();
	
				// Attach to window object in case other libraries want to use it
				window.TrimarkSourceTracker = this;
	
				// Trigger event to signal when library is initialized
				$(document).trigger('trmk:source-tracker-initialized');
			},
			/**
			 * Get source data from cookies based on the specified strategy.
			 *
			 * @returns object
			 */
			getSourceData: function() {
				const cookieName = this.settings.cookie.name[this.settings.strategy];
				return Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
			},
			/**
			 * Set source cookies based on URL parameters and referrer.
			 */
			setSourceCookies: function() {
				const params = new URLSearchParams(window.location.search);
				const cookie = {};
	
				// Save all url params in cookie object
				params.forEach((val, key) => cookie[key] = val);
	
				// Add any additional values to cookie object
				cookie['referrer'] = document.referrer;
				cookie['landing_pg'] = window.location.href;
	
				// Save first-touch cookie (only if not previously set)
				if (typeof Cookies.get(this.settings.cookie.name.ft) === 'undefined') {
					Cookies.set(this.settings.cookie.name.ft, JSON.stringify(cookie), this.settings.cookie.opts);
				}
	
				// In all instances save last-touch cookie
				Cookies.set(this.settings.cookie.name.lt, JSON.stringify(cookie), this.settings.cookie.opts);
			},
			/**
			 * Populate form fields with source data based on the specified strategy.
			 *
			 * @returns void
			 */
			populateFormFields: function() {
				if (!this.hasInit) {
					console.warn('SourceTracker has not been initialized. Please call init() before populating form fields.');
					return;
				}
	
				const cookieName = this.settings.cookie.name[this.settings.strategy];
				const vars = Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
				const _self = this;
	
				Object.keys(vars).forEach(key => {
					$(`[${_self.settings.forms.prefillAttr}="${key}"]`).each((i, el) => {
						$(el).val(vars[key]);
					});
				});
			}
		}
	
		module.init();
	
		return module;
	}
	
	/**
	 * Jquery document ready.
	 * Initialize SourceTracker library.
	 */
	$(() => {
		// Init source tracking library
		const st = new SourceTracker({
			strategy: 'ft', // "ft" or "lt" (first-touch or last-touch)
			cookie: {
				name: {
					ft: 'trmk_src_first', // cookie name : first touch attribution
					lt: 'trmk_src_last', // cookie name : last touch attribution
				},
				opts: {
					expires: 1, // 1 day
					path: '/' // full site
				}
			},
			forms: {
				prefillAttr: 'data-prefill', // the data attribute of form field to prefill
			},
		});
	
		// Gravity forms post render event
		// - Makes sure fields are always popuplated with correct cookie values even if re-rendered (i.e. validation)
		$(document).on('gform_post_render', function (event, form_id, current_page) {
			st.populateFormFields();
		});
	
		// Fallback for if gform_post_render doesn't fire
		// - gform_post_render is supposed to fire on page load, but seems to not in all cases
		st.populateFormFields();
	})
	
	$(() => {
		const CARD_SELECTOR = ".linked-hover-card";
		const TOGGLE_SELECTOR = ".member-copy-toggle";
		const MOBILE_MAX_WIDTH = 599;
	
		const isMobileInteraction = () =>
			window.innerWidth <= MOBILE_MAX_WIDTH ||
			window.matchMedia("(hover: none) and (pointer: coarse)").matches;
	
		const collapseAll = (exceptCard = null) => {
			$(CARD_SELECTOR).each((_, card) => {
				if (card !== exceptCard) {
					card.classList.remove("is-expanded");
					const button = card.querySelector(TOGGLE_SELECTOR);
					if (button) {
						button.setAttribute("aria-expanded", "false");
					}
				}
			});
		};
	
		$(document).on("click", TOGGLE_SELECTOR, (event) => {
			if (!isMobileInteraction()) {
				return;
			}
	
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
	
			const card = event.currentTarget.closest(CARD_SELECTOR);
			if (!card) {
				return;
			}
	
			const shouldExpand = !card.classList.contains("is-expanded");
	
			collapseAll(shouldExpand ? card : null);
			card.classList.toggle("is-expanded", shouldExpand);
			event.currentTarget.setAttribute(
				"aria-expanded",
				shouldExpand ? "true" : "false"
			);
		});
	
		$(document).on("click", (event) => {
			const clickedInsideCard = $(event.target).closest(CARD_SELECTOR).length > 0;
			if (isMobileInteraction() && !clickedInsideCard) {
				collapseAll();
			}
		});
	
		$(window).on("resize", () => {
			if (!isMobileInteraction()) {
				collapseAll();
			}
		});
	});
	
		document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.full-card-link[data-url]').forEach(card => {
			card.addEventListener('click', (e) => {
				const $this = $(e.currentTarget);
				const dataUrl = $this.data('url');
	
				if (dataUrl === '#popupForm') {
					$.fancybox({
						src: dataUrl,
						type: 'inline',
					});
				} else {
					if (!e.target.closest('a, button')) {
						window.location.href = card.getAttribute('data-url');
					}
				}
			});
		});
	});
	
		document.addEventListener('DOMContentLoaded', () => {
		const counters = document.querySelectorAll('.number');
	
		if (!counters.length) return;
	
		const countUp = (el) => {
			const raw = el.dataset.number || '';
	
			// Keep ONLY a leading "$" as prefix
			const prefix = raw.trim().startsWith('$') ? '$' : '';
	
			// Numeric target
			const target = parseInt(raw.replace(/[^\d]/g, ''), 10);
	
			const suffix = raw.replace(/^\$/, '').replace(/[\d,]/g, '');
	
			// Set animation duration
			const duration = 1200;
			const steps = 40;
			const increment = Math.max(Math.ceil(target / steps), 1);
			let count = 0;
	
			const interval = setInterval(() => {
				count += increment;
	
				// Stop animation at target number
				if (count >= target) {
					count = target;
					clearInterval(interval);
				}
				el.textContent = prefix + count.toLocaleString() + suffix;
			}, duration / steps);
		};
	
		// Animates only when element is fully visible
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					countUp(entry.target);
					obs.unobserve(entry.target);
				}
			});
		}, { threshold: 1.0 });
	
		counters.forEach(el => observer.observe(el));
	});
	
		$('.card-slider').each((i, el) => {
		const $slider = $(el);
		const { prevArrow, nextArrow } = Globals.sliders;
		const $controls = $slider.next('.js-slider-controls');
		const initialSlide = $slider.parents('.block-card-slider').data('initial-slide');
	
		let options = {
			mobileFirst: true,
			dots: true,
			prevArrow,
			nextArrow,
			appendArrows: $controls,
			appendDots: $controls,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '47px',
			infinite: true,
			responsive: [
				{
					breakpoint: 991,
					settings: 'unslick',
				},
			],
		};
	
		// Grid-2-across or grid-5-item (mobile slick only)
		if (
			$slider.hasClass('card-slider--grid-2-across') ||
			$slider.hasClass('card-slider--grid-5-item')
		) {
			options.slidesToShow = 1;
			options.slidesToScroll = 1;
			options.centerMode = true;
			options.centerPadding = '47px';
			options.infinite = true;
			options.responsive = [
				{
					breakpoint: 768,
					settings: 'unslick',
				},
			];
		}
	
		// Grid-3-across (mobile slick only)
		if (
			$slider.hasClass('card-slider--grid-3-across')
	
		) {
			options.slidesToShow = 1;
			options.slidesToScroll = 1;
			options.centerMode = true;
			options.centerPadding = '47px';
			options.infinite = true;
			options.responsive = [
				{
					breakpoint: 768,
					settings: 'unslick',
				},
			];
		}
	
		// Slide 2-across (1 slides on mobile, 2 slides on desktop)
		if ($slider.hasClass('card-slider--slide-2-across')) {
			options.infinite = true;
			options.centerMode = false;
			options.responsive = [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						centerMode: false,
					},
				},
			];
		}
	
		// Slide 2-across 1 peek (1 slides on mobile, 2.5 slides on desktop)
		if ($slider.hasClass('card-slider--slide-2-half-across')) {
			options.infinite = false;
			options.centerMode = false;
			options.slidesToShow = 1.15;
			options.responsive = [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2.5,
						slidesToScroll: 1,
						centerMode: false,
					},
				},
			];
		}
	
		// Reviews slider (3 slides on mobile and desktop)
		if ($slider.hasClass('card-slider--reviews')) {
			options.infinite = true;
			options.centerMode = false;
			options.responsive = [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: false,
					},
				},
			];
		}
	
		// Hide the slider controls if not enough items to slide
		$slider.on('init reInit setPosition', function (evt, slick) {
			if (!slick) return;
	
			var count = slick.slideCount;
			var sts   = slick.options.slidesToShow || 1;
			var isCenterSingle = slick.options.centerMode && sts === 1;
	
			var canSlide = isCenterSingle ? (count > 1) : (count > sts);
	
			if ($controls && $controls.length) {
			$controls.toggle(!!canSlide);
			}
		});
	
		$slider.slick(options);
	
		// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
		if ($slider.find('.slick-track').length === 0) {
			$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
			$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
		}
	});
	
		/**
	 * Filtered Product Gallery Block JavaScript
	 */
	
	(function($) {
	    'use strict';
	
	    function initFilteredProductGallery() {
	        const $galleries = $('.block-filtered-product-gallery');
	        
	        if (!$galleries.length) {
	            return;
	        }
	
	        $galleries.each(function() {
	            const $gallery = $(this);
	            const $filterColumn = $gallery.find('.filter-column');
	            const $inputs = $gallery.find('input[type="checkbox"]');
	            const $activeFilters = $gallery.find('.active-filters');
	            const $totalResults = $gallery.find('.total-results');
	            const $noResults = $gallery.find('.no-results');
	            const $blocks = $gallery.find('.gallery .block');
	            const $viewMoreWrap = $gallery.find('.view-more-wrap');
	            const $viewMoreBtn = $gallery.find('.view-more-btn');
	            const pageSize = 9;
	            let currentPage = 1;
	            
	            // Initialize Fancybox for active gallery items
	            if (typeof $.fancybox !== 'undefined') {
	                $blocks.filter('.active').fancybox({
	                    buttons: [
	                        "zoom",
	                        "slideShow",
	                        "thumbs",
	                        "close"
	                    ],
	                });
	            }
	
	            // Show/hide filters on mobile
	            $gallery.find('.show-filters').on('click', function() {
	                $filterColumn.toggleClass('open');
	            });
	
	            // Reset filters
	            $gallery.find('.reset').on('click', function() {
	                $inputs.prop('checked', false);
	                currentPage = 1;
	                resetFilters();
	            });
	
	            $viewMoreBtn.on('click', function(event) {
	                event.preventDefault();
	                currentPage += 1;
	                applyPagination();
	            });
	
	            // Handle checkbox changes
	            $inputs.on('change', function() {
	                const filter = $(this).data('filter');
	                const $filterDiv = $(this).closest('.filter');
	                const type = $filterDiv.data('filter-type');
	                const $typeContainer = $('#' + type);
	
	                if (this.checked) {
	                    $typeContainer.addClass(filter);
	                    $activeFilters.data('active', $activeFilters.data('active') + 1);
	                } else {
	                    $typeContainer.removeClass(filter);
	                    $activeFilters.data('active', $activeFilters.data('active') - 1);
	                }
	
	                currentPage = 1;
	                updateGallery();
	            });
	
	            function resetFilters() {
	                $activeFilters.children().removeClass();
	                $activeFilters.data('active', 0);
	                updateGallery();
	            }
	
	            function applyPagination() {
	                $blocks.removeClass('is-hidden');
	                const $activeBlocks = $blocks.filter('.active');
	                const totalActive = $activeBlocks.length;
	                const visibleCount = currentPage * pageSize;
	
	                $activeBlocks.each(function(index) {
	                    if (index >= visibleCount) {
	                        $(this).addClass('is-hidden');
	                    }
	                });
	
	                if (totalActive > visibleCount) {
	                    $viewMoreWrap.addClass('is-visible');
	                } else {
	                    $viewMoreWrap.removeClass('is-visible');
	                }
	            }
	
	            function updateGallery() {
	                // Hide everything first
	                $blocks.removeClass('active');
	
	                const activeCount = $activeFilters.data('active');
	
	                if (activeCount > 0) {
	                    // Start with all blocks
	                    let $filtered = $blocks;
	
	                    // Filter by each type
	                    ['product_type', 'window_style', 'window_grid', 'color'].forEach(function(filterType) {
	                        const $filterContainer = $('#filter-' + filterType);
	                        const classes = $filterContainer.attr('class');
	                        
	                        if (classes && classes.trim() !== '') {
	                            const selectors = '.' + classes.trim().replace(/ +/g, ', .');
	                            $filtered = $filtered.filter(selectors);
	                        }
	                    });
	
	                    $filtered.addClass('active');
	                } else {
	                    // Show everything
	                    $blocks.addClass('active');
	                }
	
	                // Update results count
	                const total = $blocks.filter('.active').length;
	                
	                if (total === 0) {
	                    $totalResults.text('0 Results');
	                    $noResults.addClass('active');
	                    $viewMoreWrap.removeClass('is-visible');
	                } else {
	                    $noResults.removeClass('active');
	                    if (total === 1) {
	                        $totalResults.text('1 Result');
	                    } else {
	                        $totalResults.text(total + ' Results');
	                    }
	                }
	
	                applyPagination();
	
	                // Reinitialize Fancybox with active items only
	                if (typeof $.fancybox !== 'undefined') {
	                    $.fancybox.destroy();
	                    $blocks.filter('.active').fancybox({
	                        buttons: [
	                            "zoom",
	                            "slideShow",
	                            "thumbs",
	                            "close"
	                        ],
	                    });
	                }
	            }
	
	            // Initial pagination state on page load
	            currentPage = 1;
	            applyPagination();
	        });
	    }
	
	    // Initialize on document ready
	    $(document).ready(function() {
	        initFilteredProductGallery();
	    });
	
	    // Re-initialize on ACF block preview refresh (in editor)
	    if (window.acf) {
	        window.acf.addAction('render_block_preview/type=filtered-product-gallery', function() {
	            initFilteredProductGallery();
	        });
	    }
	
	})(jQuery);
	
		document.addEventListener('DOMContentLoaded', function () {
		// Add 'three-cards' class if exactly 3 cards exist
		document.querySelectorAll('.horizontal-accordion').forEach(accordion => {
			if (accordion.querySelectorAll('.block-link-card').length === 3) {
				accordion.classList.add('three-cards');
			}
		});
	
		// jQuery accordion logic
		const $accordionItems = $('.horizontal-accordion .link-card');
		const $dotsContainer = $('.accordion-dots');
		const $nextBtn = $('.js-slider-controls .next');
		const $prevBtn = $('.js-slider-controls .prev');
	
		if (!$accordionItems.length) return;
	
		let currentIndex = 0;
	
		const setActiveItem = (index) => {
			$accordionItems.addClass('closed').each(function () {
				$(this).closest('.block-link-card').addClass('closed');
			});
	
			$accordionItems.eq(index).removeClass('closed').closest('.block-link-card').removeClass('closed');
			currentIndex = index;
	
			$dotsContainer.find('button').removeClass('active').eq(index).addClass('active');
		};
	
		// Generate dots
		$accordionItems.each((i) => {
			$('<button>', {
				type: 'button',
				'aria-label': `Go to item ${i + 1}`,
				class: i === 0 ? 'active' : '',
				click: () => setActiveItem(i)
			}).appendTo($dotsContainer);
		});
	
		// Initialize
		setActiveItem(0);
	
		// Click handler for items
		$accordionItems.on('click', function (e) {
			if (!$(this).hasClass('closed')) return;
			e.preventDefault();
			setActiveItem($accordionItems.index(this));
		});
	
		// Arrow navigation
		$nextBtn.on('click', () => setActiveItem((currentIndex + 1) % $accordionItems.length));
		$prevBtn.on('click', () => setActiveItem((currentIndex - 1 + $accordionItems.length) % $accordionItems.length));
	});
	
		function initImageComparisons() {
		const comps = document.querySelectorAll(".image-comparison");
		if (!comps.length) return;
	
		comps.forEach((comp) => {
			const overlay = comp.querySelector(".img-comp-overlay");
			if (!overlay) return;
	
			// Build the slider bar
			const slider = document.createElement("div");
			slider.className = "img-comp-slider";
			slider.innerHTML =
				"<span class='circle'><i class='fas fa-chevron-left'></i><i class='fas fa-chevron-right'></i></span>";
			comp.insertBefore(slider, comp.firstChild);
	
			let dragging = false;
			let percentage = 0.5;
	
			function clamp(val, min, max) {
				return Math.max(min, Math.min(val, max));
			}
	
			function setPositionByX(x) {
				const w = comp.clientWidth || 0;
				x = clamp(x, 0, w);
				percentage = w ? x / w : 0.5;
				overlay.style.clipPath = `inset(0 ${w - x}px 0 0)`;
				overlay.style.webkitClipPath = `inset(0 ${w - x}px 0 0)`;
				slider.style.left = x - slider.offsetWidth / 2 + "px";
			}
	
			function setPositionBypercentage(p) {
				const w = comp.clientWidth || 0;
				setPositionByX(p * w);
			}
	
			function getXFromEvent(e) {
				const rect = comp.getBoundingClientRect();
				const clientX =
					e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
				return clientX - rect.left - window.pageXOffset;
			}
	
			function onDown(e) {
				e.preventDefault();
				dragging = true;
				document.addEventListener("mousemove", onMove);
				document.addEventListener("touchmove", onMove, { passive: false });
			}
	
			function onUp() {
				dragging = false;
				document.removeEventListener("mousemove", onMove);
				document.removeEventListener("touchmove", onMove);
			}
	
			function onMove(e) {
				if (!dragging) return;
				e.preventDefault();
				setPositionByX(getXFromEvent(e));
			}
	
			// Start centered
			setPositionBypercentage(percentage);
	
			// Events
			slider.addEventListener("mousedown", onDown);
			document.addEventListener("mouseup", onUp);
			slider.addEventListener("touchstart", onDown, { passive: false });
			document.addEventListener("touchend", onUp);
	
			// Keep position on resize
			window.addEventListener("resize", () =>
				setPositionBypercentage(percentage)
			);
		});
	}
	
	document.addEventListener("DOMContentLoaded", initImageComparisons);
	
		(function () {
		function initGallery(block) {
			var galleryRowsContainer = block.querySelector('.image-rows');
			var viewMoreButtonWrapper = block.querySelector('.view-more-wrap');
			var viewMoreButton = block.querySelector('.view-more-btn');
			if (!galleryRowsContainer || !viewMoreButtonWrapper || !viewMoreButton) return;
			if (viewMoreButton.dataset.breezeBound === 'true') return;
	
			var remainingImages = JSON.parse(
				galleryRowsContainer.getAttribute('data-remaining') || '[]'
			);
			var currentImageIndex = 0;
	
			if (remainingImages.length === 0) {
				viewMoreButtonWrapper.style.display = 'none';
				return;
			}
	
			viewMoreButton.dataset.breezeBound = 'true';
			viewMoreButton.addEventListener('click', function (event) {
				event.preventDefault();
	
				var nextImages = remainingImages.slice(currentImageIndex, currentImageIndex + 5);
				if (nextImages.length === 0) {
					viewMoreButtonWrapper.style.display = 'none';
					return;
				}
	
				var newGalleryRow = document.createElement('div');
				newGalleryRow.className = 'gallery-row';
	
				var bigImageHTML = nextImages[0]
					? '<figure class="gallery-single"><a href="' + nextImages[0].src + '" data-fancybox="image-gallery"><img class="gallery-img" src="' + nextImages[0].src + '" alt="' + (nextImages[0].alt || '') + '"></a></figure>'
					: '<figure class="gallery-single gallery-empty"></figure>';
	
				var smallImagesHTML = '<div class="gallery-quad">';
				for (var i = 1; i < 5; i++) {
					var smallImage = nextImages[i];
					smallImagesHTML += smallImage
						? '<figure class="gallery-cell"><a href="' + smallImage.src + '" data-fancybox="image-gallery"><img class="gallery-img" src="' + smallImage.src + '" alt="' + (smallImage.alt || '') + '"></a></figure>'
						: '<figure class="gallery-cell gallery-empty"></figure>';
				}
				smallImagesHTML += '</div>';
	
				newGalleryRow.innerHTML = bigImageHTML + smallImagesHTML;
				galleryRowsContainer.appendChild(newGalleryRow);
	
				currentImageIndex += nextImages.length;
				if (currentImageIndex >= remainingImages.length) {
					viewMoreButtonWrapper.style.display = 'none';
				}
			});
		}
	
		function initAllGalleries(root) {
			var scope = root || document;
			var blocks = scope.querySelectorAll('.block-image-gallery');
			if (!blocks.length) return;
			blocks.forEach(initGallery);
		}
	
		initAllGalleries();
	
		// Re-init when a tab is shown (tabs can hide panes before JS binds).
		document.addEventListener('shown.bs.tab', function (event) {
			var target = event && event.target;
			if (!target || !target.getAttribute) return;
			var paneSelector = target.getAttribute('data-bs-target');
			if (!paneSelector) return;
			var pane = document.querySelector(paneSelector);
			if (!pane) return;
			initAllGalleries(pane);
		});
	
		// Re-init when a tab accordion pane opens on mobile.
		document.addEventListener('shown.bs.collapse', function (event) {
			var pane = event && event.target;
			if (!pane || !pane.querySelectorAll) return;
			initAllGalleries(pane);
		});
	})();
	  
	
		document.addEventListener("DOMContentLoaded", () => {
		// =======================================================================
		// SETUP
		// =======================================================================
	
		/**
		 * Ensure Google Maps API is loaded
		 */
		if (
			typeof google === "undefined" ||
			!google.maps ||
			!google.maps.importLibrary
		) {
			return;
		}
	
		/**
		 * The main element selector for the map(s).
		 * @type {string}
		 */
		const mapElement = ".interactive-map__element";
	
		/**
		 * Global variables for the map and markers.
		 * Save here for performance and to avoid re-loading libraries.
		 */
		let allMarkerData;
		let map;
		let clusterer;
		let libraries;
		let imagePath = '/wp-content/themes/breeze/dist/images/icons';
		let markerImage = `${imagePath}/map-pin-royal-blue.svg`;
		let advancedMarkerImage = `${imagePath}/map-pin.svg`;
	
		// =======================================================================
		// LOAD GOOGLE LIBRARIES ASYNC
		// =======================================================================
	
		/**
		 * Load the necessary Google Maps libraries.
		 */
		async function loadGoogleMapsLibraries() {
			// Only load once
			// if (Map && InfoWindow && Marker && AdvancedMarkerElement && LatLngBounds) return;
			const [
				{ Map, InfoWindow },
				{ Marker, AdvancedMarkerElement },
				{ LatLngBounds, ControlPosition },
				{ PlaceAutocompleteElement },
				{ Geocoder },
			] = await Promise.all([
				google.maps.importLibrary("maps"),
				google.maps.importLibrary("marker"),
				google.maps.importLibrary("core"),
				google.maps.importLibrary("places"),
				google.maps.importLibrary("geocoding"),
			]);
			libraries = {
				Map,
				InfoWindow,
				Geocoder,
				Marker,
				AdvancedMarkerElement,
				LatLngBounds,
				ControlPosition,
				PlaceAutocompleteElement,
				MarkerClusterer: markerClusterer.MarkerClusterer,
			};
		}
	
		/**
		 * Initialize the map(s) once the libraries are loaded.
		 */
		loadGoogleMapsLibraries()
			.then(() => {
				// Libraries loaded
				document.querySelectorAll(mapElement).forEach((el) => {
					new InteractiveMap(el);
				});
			})
			.catch((error) => {
				console.error("Error loading Google Maps libraries:", error);
			});
	
		// =======================================================================
		// MAIN FUNCTION TO KICK OFF THE MAP AND CLUSTERING
		// =======================================================================
	
		/**
		 * Our main function to initialize the map and clustering.
		 *
		 * @param {DOMElement} mapElement The map container element.
		 */
		function InteractiveMap(mapElement) {
			try {
				const defaultZoom = mapElement.getAttribute("data-zoom") || 12;
				const markerDataResult = getMarkerData(mapElement);
				const enableSearch = mapElement.getAttribute("data-enable-search") === "true";
				const addressFromURL = getAddressFromURL();
				const newMarkerImg = mapElement.getAttribute("data-marker-image");
				let bounds;
	
				// Save some global data
				allMarkerData = markerDataResult;
				bounds = getBoundsForMarkers(allMarkerData);
				map = createMap(mapElement, defaultZoom);
				clusterer = new libraries.MarkerClusterer({ map, renderer: markerClustererRenderer });
	
				// Marker image override from data attribute
				if (newMarkerImg && newMarkerImg === 'branded') markerImage = `${imagePath}/map-pin-branded.svg`;
	
				// Fit the map to the bounds of the markers
				fitMapToBounds(map, bounds, allMarkerData.data.length, defaultZoom);
	
				// Initial render of markers
				filterAndRenderMarkers();
	
				// If enabled, initialize the search box
				// If an address is present in the URL, zoom to that address
				if (enableSearch) initializeSearch(mapElement, defaultZoom);
				if (addressFromURL) zoomToAddress(addressFromURL);
	
				// Re-filter markers when the map becomes idle after panning/zooming
				map.addListener("idle", () => filterAndRenderMarkers());
			} catch (error) {
				console.error("Error initializing InteractiveMap:", error);
			}
		}
	
		// =======================================================================
		// MARKER CLUSTER RENDERER
		// =======================================================================
	
		/**
		 * Custom renderer for marker clusters.
		 * Creates SVG icons with different colors based on cluster size.
		 */
		const markerClustererRenderer = {
			render: ({ count, position }, stats) => {
				const max = stats.clusters.markers.max;
				let color, size;
	
				// Determine color and size based on count
				if (count <= max / 3) {
					color = "#0099F3"; // Low Range (Electric Blue)
					size = 50;
				} else if (count <= (max * 2) / 3) {
					color = "#0B2B90"; // Mid Range (Royal Blue)
					size = 50;
				} else {
					color = "#030C28"; // High Range (Dark Blue)
					size = 50;
				}
	
				// create svg literal with fill color and dynamic size
				const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="${size}" height="${size}">
					<circle cx="120" cy="120" opacity=".8" r="70" />
					<circle cx="120" cy="120" opacity=".6" r="90" />
					<circle cx="120" cy="120" opacity=".3" r="110" />
					<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
				</svg>`;
	
				const title = `Cluster of ${count} markers`,
				// adjust zIndex to be above other markers
				zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
	
				const clusterOptions = {
					position,
					zIndex,
					title,
					icon: {
						url: `data:image/svg+xml;base64,${btoa(svg)}`,
						anchor: new google.maps.Point(size / 2, size / 2),
					},
				};
	
				return new libraries.Marker(clusterOptions);
			},
		};
	
		// =======================================================================
		// ADDRESS AND SEARCH FUNCTIONS
		// =======================================================================
	
		/**
		 * Gets the address from the URL parameter.
		 *
		 * @returns {string|boolean} The address from the URL parameter or false if not present.
		 */
		function getAddressFromURL() {
			const urlParams = new URLSearchParams(window.location.search);
			return urlParams.get("address") || false;
		}
	
		/**
		 * Zooms the map to the specified address.
		 *
		 * @param {string} address
		 */
		function zoomToAddress(address) {
			const geocoder = new libraries.Geocoder();
			const isZipCode = /^\d{5}$/.test(address);
	
			geocoder.geocode({ address }, (results, status) => {
				if (status === "OK" && results[0]) {
					map.setCenter(results[0].geometry.location);
					map.setZoom(isZipCode ? 12 : 14);
				} else {
					console.error(
						"Geocode was not successful for the following reason: " +
							status
					);
				}
			});
		}
	
		/**
		 * Initializes the search functionality.
		 *
		 * @param {string} defaultZoom
		 */
		function initializeSearch(mapContainer, defaultZoom) {
			const placeAutocomplete = new libraries.PlaceAutocompleteElement();
	
			placeAutocomplete.id = "place-autocomplete-input";
			// Use the actual input element (new Maps API) or fall back to the element itself.
			const placeholderTarget =
				placeAutocomplete.inputElement || placeAutocomplete;
			if (placeholderTarget?.setAttribute) {
				placeholderTarget.setAttribute(
				"placeholder",
				"Search for address..."
			);
			}
			// Keep the control inside the map container to avoid duplicate layout space.
			if (mapContainer?.appendChild) {
				mapContainer.appendChild(placeAutocomplete);
			}
			map.controls[libraries.ControlPosition.TOP_LEFT].push(
				placeAutocomplete
			);
	
			// Bias the SearchBox results towards current map's viewport.
			map.addListener("bounds_changed", () => {
				placeAutocomplete.locationRestriction = map.getBounds();
			});
	
			// Add the gmp-placeselect listener, and display the results.
			placeAutocomplete.addEventListener(
				"gmp-select",
				async ({ placePrediction }) => {
					const place = placePrediction.toPlace();
					await place.fetchFields({
						fields: ["displayName", "formattedAddress", "location"],
					});
	
					// If the place has a geometry, then present it on a map.
					if (place.viewport) {
						map.fitBounds(place.viewport);
					} else {
						map.setCenter(place.location);
					}
	
					map.setZoom(defaultZoom);
				}
			);
		}
	
		// =======================================================================
		// THE MAP HANDLING FUNCTIONS
		// - MARKERS, BOUNDS, CLUSTERING, ETC.
		// =======================================================================
	
		/**
		 * Creates a Google Map instance.
		 *
		 * @param {DOMElement} mapElement
		 * @param {string} defaultZoom
		 * @returns {libraries.Map}
		 */
		function createMap(mapElement, defaultZoom) {
			return new libraries.Map(mapElement, {
				mapId: "2d358a6df0bdc6efc9df65d7", // custom styled map (controled in cloud console)
				zoom: parseInt(defaultZoom), // default zoom level
				disableDefaultUI:
					mapElement.getAttribute("data-disable-default-ui") === "true", // disable all default UI
				clickableIcons: false, // citys, POIs, etc. are not clickable
				mapTypeControl: false, // always disable map/satellite toggle
				streetViewControl: false, // always disable street view button
			});
		}
	
		/**
		 * Gets the marker data from the map element.
		 *
		 * @param {DOMElement} mapElement
		 * @returns {Object} Marker data and library
		 */
		function getMarkerData(mapElement) {
			// If using the jobs data source, we expect a global `jobs` variable to be present
			if (typeof jobs !== "undefined" && Array.isArray(jobs)) {
				return { data: jobs, library: libraries.Marker };
				// Otherwise, we expect marker data JSON encoded in a data attribute
			} else {
				return {
					data: JSON.parse(mapElement.getAttribute("data-markers")) || [],
					library: libraries.AdvancedMarkerElement,
				};
			}
		}
	
		/**
		 * Gets the bounds for the markers.
		 *
		 * @param {Object} markerData
		 * @returns {libraries.LatLngBounds}
		 */
		function getBoundsForMarkers(markerData) {
			const bounds = new libraries.LatLngBounds();
			markerData.data.forEach((marker) => {
				bounds.extend({
					lat: parseFloat(marker.lat),
					lng: parseFloat(marker.lng),
				});
			});
			return bounds;
		}
	
		/**
		 * Fits the map to the bounds of the markers.
		 *
		 * @param {libraries.Map} map
		 * @param {libraries.LatLngBounds} bounds
		 * @param {number} markerCount
		 * @param {string} defaultZoom
		 */
		function fitMapToBounds(map, bounds, markerCount, defaultZoom) {
			if (markerCount === 1 && defaultZoom) {
				map.setCenter(bounds.getCenter());
				map.setZoom(parseInt(defaultZoom));
			} else if (markerCount > 100) {
				map.fitBounds(bounds, 50);
			} else {
				map.fitBounds(bounds);
			}
		}
	
		/**
		 * Filters and renders markers on the map based on the current bounds.
		 *
		 * Note on marker types:
		 * - Marker: More performant, but less flexible styling options.
		 * - AdvancedMarkerElement: More flexible styling options, but less performant.
		 *
		 * We choose the marker type based on the data source.
		 * If using the jobs data source, we use Marker for performance.
		 * If using custom uploaded data, we use AdvancedMarkerElement for flexibility.
		 *
		 * For more info on AdvancedMarkerElement performance issues:
		 * @link https://issuetracker.google.com/issues/333423690#comment17
		 * @link https://issuetracker.google.com/issues/333423690#comment35
		 *
		 * @returns {void}
		 */
		function filterAndRenderMarkers() {
			const bounds = map.getBounds();
			const MarkerLibrary = allMarkerData.library;
	
			if (!bounds) return;
	
			// Determine which markers are within the current bounds
			const visibleMarkerData = allMarkerData.data.filter((markerData) => {
				const markerPosition = new google.maps.LatLng(
					parseFloat(markerData.lat),
					parseFloat(markerData.lng)
				);
				return bounds.contains(markerPosition);
			});
	
			// Create new markers but do not add to map yet (done by clusterer)
			const newMarkers = visibleMarkerData.map((markerData) => {
				const marker = new MarkerLibrary({
					position: {
						lat: parseFloat(markerData.lat),
						lng: parseFloat(markerData.lng),
					},
					title:
						markerData.name && markerData.name.length
							? markerData.name
							: "",
				});
	
				// Legacy Marker (used only for complete jobs map)
				// - More performant for large number of markers
				// - No InfoWindow
				if (MarkerLibrary === libraries.Marker) {
					marker.setIcon(markerImage);
	
				// AdvancedMarkerElement (should only be used for less than 20 markers ideally)
				// - Activate InfoWindow on click
				} else if (MarkerLibrary === libraries.AdvancedMarkerElement) {
					marker.content = (() => {
						const pinImage = document.createElement("img");
						pinImage.src = advancedMarkerImage;
						return pinImage;
					})();
					marker.gmpClickable = true;
	
					const infoWindow = new libraries.InfoWindow();
					marker.addListener("click", ({ domEvent, latLng }) => {
						const { target } = domEvent;
						infoWindow.close();
						infoWindow.setContent(marker.title);
						infoWindow.open(marker.map, marker);
					});
				}
	
				return marker;
			});
	
			// Clear existing markers from the clusterer and add new ones for the current bounds
			clusterer.clearMarkers();
			clusterer.addMarkers(newMarkers);
		}
	});
	
		(function ($) {
		function run($el) {
			var count = Number($el.data("count")) || 0;
			var show = window.innerWidth < 768 ? 4 : 6;
			var needsSlider = count > show;
			var isSliderInitialized = $el.hasClass("slick-initialized");
	
			if (needsSlider && !isSliderInitialized) {
				$el.slick({
					mobileFirst: true,
					slidesToShow: Math.min(show, count),
					slidesToScroll: 1,
					infinite: true,
					autoplay: true,
					autoplaySpeed: 3000,
					dots: false,
					arrows: false,
				});
			} else if (!needsSlider && isSliderInitialized) {
				$el.slick("unslick");
			} else if (needsSlider && isSliderInitialized) {
				var want = Math.min(show, count);
				var curr = $el.slick("slickGetOption", "slidesToShow");
				if (curr !== want) {
					$el.slick("slickSetOption", "slidesToShow", want, true);
					$el.slick("slickSetOption", "slidesToScroll", 1, true);
				}
			}
		}
	
		function runAll() {
			$(".block-logo-slider .logo-slider").each(function () {
				run($(this));
			});
		}
	
		$(function () {
			runAll();
			$(window).on("resize orientationchange", function () {
				clearTimeout(window._logoT);
				window._logoT = setTimeout(runAll, 120);
			});
		});
	})(jQuery);
	
		(() => {
		document.querySelectorAll(".block-pricing-calculator").forEach((block) => {
			const input = block.querySelector("[data-qty-input]");
			const priceWrap = block.querySelector(".estimated-price");
			const minusBtn = block.querySelector("[data-qty-minus]");
			const plusBtn = block.querySelector("[data-qty-plus]");
	
			if (!input || !priceWrap) return;
	
			const priceSpan = priceWrap.querySelector("span");
			const priceItems = priceWrap.querySelectorAll("[data-price-item]");
			const maxQty = parseInt(input.dataset.maxQty, 10) || null;
	
			const basePrice = parseFloat(priceWrap.dataset.basePrice) || 0;
			const baseAltPrice = parseFloat(priceWrap.dataset.basePriceAlt) || 0;
	
			// Number formatter (1234 -> 1,234)
			const formatNumber = (n) =>
				new Intl.NumberFormat("en-US").format(Number(n) || 0);
			
	
			const clamp = (n) => {
				let val = Math.max(1, n || 1);
				if (maxQty) val = Math.min(maxQty, val);
				return val;
			};
	
			const updateButtonState = (qty) => {
				if (minusBtn) {
					const disabled = qty === 1;
					minusBtn.style.opacity = disabled ? "0.5" : "1";
					minusBtn.style.cursor = disabled ? "default" : "pointer";
				}
	
				if (plusBtn && maxQty) {
					const disabled = qty === maxQty;
					plusBtn.style.opacity = disabled ? "0.5" : "1";
					plusBtn.style.cursor = disabled ? "default" : "pointer";
				}
			};
	
			const updatePrice = (qty) => {
				if (priceItems.length) {
					priceItems.forEach((item) => {
						const base = parseFloat(item.dataset.basePrice) || 0;
						const span = item.querySelector("span");
						if (span) span.textContent = `$${formatNumber(base * qty)}`;
					});
				} else {
					const min = basePrice * qty;
					const max = baseAltPrice * qty;
					if (priceSpan) priceSpan.textContent = `$${formatNumber(min)} - $${formatNumber(max)}`;
				}
	
				updateButtonState(qty);
			};
	
			const getValue = () => clamp(parseInt(input.value, 10));
			const setValue = (n) => {
				const qty = clamp(n);
				input.value = String(qty);
				updatePrice(qty);
			};
	
			minusBtn?.addEventListener("click", (e) => {
				e.preventDefault();
				setValue(getValue() - 1);
			});
	
			plusBtn?.addEventListener("click", (e) => {
				e.preventDefault();
				setValue(getValue() + 1);
			});
	
			["input", "change", "blur"].forEach((evt) =>
				input.addEventListener(evt, () => setValue(getValue()))
			);
	
			updatePrice(getValue());
		});
	})();
	
		  
	  jQuery(function ($) {
	  
	    // Slick sliders init
	    const $mainSlider = $('.mobile-main-slider');
	    const $thumbSlider = $('.mobile-thumb-slider');
	  
	    if ($mainSlider.length && $thumbSlider.length) {
	      const thumbCount = $thumbSlider.find('.thumb').length;
	  
	      $mainSlider.slick({
	        arrows: false,
	        slidesToShow: 1,
	        asNavFor: '.mobile-thumb-slider',
	        fade: true,
	        draggable: true,
	        infinite: true
	      });
	  
	      $thumbSlider.slick({
	        slidesToShow: Math.min(thumbCount, 4),
	        asNavFor: '.mobile-main-slider',
	        focusOnSelect: true,
	        arrows: false,
	        variableWidth: true,
	        infinite: true,
	        centerMode: false
	      });
	    }
	
	    // --- Mobile "tap to interact" for iframe 360 product ---
	    const $mobileIframeWrappers = $('.block-product-gallery .mobile-layout .iframe-wrapper');
	
	    if ($mobileIframeWrappers.length) {
	      // Add a small hint badge
	      $mobileIframeWrappers.each(function () {
	        const $w = $(this);
	        if (!$w.find('.iframe-hint').length) {
	          $w.append('<div class="iframe-hint">Tap to interact</div>');
	        }
	      });
	
	      function deactivate($wrap) {
	        $wrap.removeClass('is-interactive');
	        const t = $wrap.data('iframeTimer');
	        if (t) { clearTimeout(t); $wrap.removeData('iframeTimer'); }
	      }
	
	      function activate($wrap) {
	        $wrap.addClass('is-interactive');
	        const t = $wrap.data('iframeTimer');
	        if (t) clearTimeout(t);
	        $wrap.data('iframeTimer', setTimeout(function () {
	          deactivate($wrap);
	        }, 8000));
	      }
	
	      // First tap enables interaction; no preventDefault so a swipe can still scroll if needed
	      $mobileIframeWrappers.on('touchstart', function () {
	        const $wrap = $(this);
	        if (!$wrap.hasClass('is-interactive')) {
	          activate($wrap);
	        }
	      });
	
	      // Any page scroll turns interaction back off (keeps scrolling natural)
	      let scroll = null;
	      $(window).on('scroll', function () {
	        if (scroll) cancelAnimationFrame(scroll);
	        scroll = requestAnimationFrame(function () {
	          $mobileIframeWrappers.filter('.is-interactive').each(function () {
	            deactivate($(this));
	          });
	        });
	      });
	
	      // If your mobile slider changes slides, disable interaction so next slide scrolls normally
	      if ($mainSlider && $mainSlider.length) {
	        $mainSlider.on('beforeChange', function () {
	          $mobileIframeWrappers.filter('.is-interactive').each(function () {
	            deactivate($(this));
	          });
	        });
	      }
	    }
	  });
	  
		(function () {
		var blocks = document.querySelectorAll('.block-savings-calculator .range-slider');
		if (!blocks.length) return;
	  
		blocks.forEach(function (range) {
		  var input = range.querySelector('.range-input');
		  var sliderNumbers  = range.querySelectorAll('.slider-display .calc-number');
		  var savingsNumbers = range.querySelectorAll('.range-display .calc-number');
		  var display = range.querySelector('.slider-display');
	  
		  if (!input) return;
	  
		  set(0);
		  move(0);
	  
		  input.addEventListener('input', function () {
			var i = parseInt(input.value, 10) || 0;
			set(i);
			move(i);
		  });
	  
		  function set(index) {
			sliderNumbers.forEach(function (n) { n.classList.remove('active'); });
			savingsNumbers.forEach(function (n) { n.classList.remove('active'); });
			if (sliderNumbers[index]) sliderNumbers[index].classList.add('active');
			if (savingsNumbers[index]) savingsNumbers[index].classList.add('active');
		  }
	  
		  function move(index) {
			if (!display) return;
			var max = parseInt(input.max, 10) || (sliderNumbers.length ? sliderNumbers.length - 1 : 5);
			var offset = window.innerWidth < 640 ? 6 : 1.75;
			var percentage = (100 / max) - offset;
			display.style.left = (index * percentage) + '%';
		  }
		});
	  })();  
		(() => {
	    let last = 0;
	
		// Simple little script to make sure columns don't reflow when accordions are opened.
		// @link https://stackoverflow.com/a/51062093
	    $('.service-areas-accordion .accordion-item').each((i, el) => {
			const $this = $(el);
	        if ($this.offset()['top'] <= last) {
	            // start of new column
	            $this.css({
	                'column-break-before': 'always',
	                'break-before': 'column'
	            });
	        }
	        last = $this.offset()['top'];
	    });
	})();
		$('.sticky-sidebar').each((i, el) => {
			const $el = $(el);
			const $main = $el.find('.sticky-sidebar__main');
			const $sidebar = $el.find('.sticky-sidebar__sidebar');
			const $headings = $main.find('h2, h3, h4, h5, h6');
	
			$headings.each((i, heading) => {
				const $this = $(heading);
				const id = $this.text().replace(/\s/g, "-").toLowerCase();
	
				$this.prepend(`<a class="anchor" id="${id}"></a>`);
	
				$sidebar.find('ul').append(`
					<li class="wp-block-button is-style-link-text-black">
						<a href="#${id}" class="wp-block-button__link">
							${$this.text()}
						</a>
					</li>
				`);
			});
	});
	
		// Adjust popover so it doesn't go off-screen on mobile
	(function () {
	    if (window._swatchesInit) return;
	    window._swatchesInit = true;
	  
	    function adj(pop) {
	      requestAnimationFrame(function () {
	        pop.classList.remove('is-edge-left');
	        pop.classList.remove('is-edge-right');
	        var r = pop.getBoundingClientRect();
	        var pad = 8;
	        if (r.left < pad) pop.classList.add('is-edge-left');
	        if (r.right > (window.innerWidth - pad)) pop.classList.add('is-edge-right');
	      });
	    }
	  
	    function init() {
	      var swatches = document.querySelectorAll('.swatch');
	  
	      for (var i = 0; i < swatches.length; i++) {
	        (function (s) {
	          var pop = s.querySelector('.swatch__popover');
	          if (!pop) return;
	          function h() { adj(pop); }
	          s.addEventListener('pointerenter', h);
	          s.addEventListener('focusin', h);
	        })(swatches[i]);
	      }
	  
	      window.addEventListener('resize', function () {
	        for (var i = 0; i < swatches.length; i++) {
	          var p = swatches[i].querySelector('.swatch__popover');
	          if (p) adj(p);
	        }
	      });
	    }
	  
	    if (document.readyState === 'loading') {
	      document.addEventListener('DOMContentLoaded', init);
	    } else {
	      init();
	    }
	  })();
		$(() => {
		// Loop through any child blocks and wrap them in a tab pane.
		$('.tabbed-content').each((i, el) => {
			const $module = $(el);
			const $tabs = $module.find('.tabbed-content__tabs');
			const $content = $module.find('.tabbed-content__content');
	
			$content.children().each((i, el) => {
				const $planSlider = $(el);
				const $tab = $tabs.find('.tab-btn').eq(i);
				const tabID = $tab.attr('aria-controls');
				const tabName = $tab.parent().data('tab-name');
				const tabHtml = $tab.html();
				const uniqid = Math.random().toString(36).substring(2, 15);
				const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="#C1A367" d="M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z"/><path fill="#C1A367" d="M7.188 12.825a.687.687 0 0 1-.688-.688v-.274c0-.38.308-.688.688-.688h9.625c.38 0 .687.308.687.688v.274c0 .38-.308.688-.688.688H7.188Z"/><path fill="#C1A367" d="M11.175 7.188c0-.38.308-.688.688-.688h.274c.38 0 .688.308.688.688v9.625c0 .38-.308.687-.688.687h-.274a.687.687 0 0 1-.688-.688V7.188Z" class="pipe"/></svg>`;
	
				// Wrap the inner blocks in tab panes for desktop tabs.
				$planSlider.wrapAll(`<div class="tab-pane fade ${i === 0 ? 'show active' : ''}" data-tab-name="${tabName}" id="${tabID}" role="tabpanel" aria-labelledby="${$tab.attr('id')}" tabindex="0"><div id="accordion-${uniqid}" class="accordion-collapse collapse"><div class="accordion-tab-body"></div></div></div>`)
	
				// Add accordion toggle button for mobile (inside tab pane, at top).
				$(`#${tabID}`).prepend(`<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordion-${uniqid}" aria-expanded="true" aria-controls="accordion-${uniqid}">${tabHtml+plusIcon}</button>`);
			});
		});
	
		// Refresh any slick sliders when a tab is shown.
		$('.tab-btn').on('shown.bs.tab', e => {
			const $target = $(e.target);
			const $tabPane = $target.data('bs-target');
			const $slider = $($tabPane).find('.card-slider');
			if ($slider.length) {
				$slider.slick('setPosition');
			}
		})
	})
	

	// ========================================================
	// GENERIC SLICK SLIDER
	// - Control options with data-slick
	// ========================================================

	const $sliders = $(".js-slider");

	// Check for sliders and loop through each
	if ($sliders.length) {
		$sliders.each((i, el) => {
			const $slider = $(el);
			const $controls = $slider.next(".js-slider-controls");
			const $filler = $slider.find(".is-col-filler");
			const { nextArrow, prevArrow } = Globals.sliders;

			// Initialize Slick
			$slider.slick({
				nextArrow,
				prevArrow,
			});

			// If there is a controls slot, add arrows and dots there.
			if ($controls.length) {
				$slider.slick("setOption", "appendDots", $controls, true);
				$slider.slick("setOption", "appendArrows", $controls, true);
			}

			// Remove any filler cards
			if ($filler.length) {
				const lastSlide = $slider.find("[data-slick-index]").length - 1;
				$slider.slick("slickRemove", lastSlide);
			}

			// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
			if ($slider.find(".slick-track").length === 0) {
				$slider
					.find("> *")
					.removeAttr("aria-describedby role tabindex aria-hidden");
				$slider
					.find('a[tabindex="-1"], button[tabindex="-1"]')
					.removeAttr("tabindex");
			}
		});
	}

	/**
	 * Mobile Step 2 Trigger Button
	 */

	jQuery(function ($) {
		$(document).on("click", ".step-2-trigger", function (e) {
			if (window.innerWidth <= 767) {
				// mobile only
				e.preventDefault();
				$("#popupForm").addClass("step-2-active");
			}
		});

		function resetStep() {
			$("#popupForm").removeClass("step-2-active");
		}

		$(document).on(
			"click",
			'a[href="#popupForm"], [data-src="#popupForm"]',
			resetStep
		);
		$(document).on("beforeClose.fb afterClose.fb", resetStep);
	});

	// ========================================================
	// SUPERSCRIPTS
	// Replace symbols with subscripted or superscripted versions
	// ========================================================
	$("p,h1,h2,h3,h4,li,a").each(function () {
		var $this = $(this);
		// Superscripts (English)
		$this.html($this.html().replace(/&dagger;|†/gi, "<sup>&dagger;</sup>"));
		$this.html($this.html().replace(/&Dagger;|‡/gi, "<sup>&Dagger;</sup>"));
		$this.html($this.html().replace(/&reg;|®/gi, "<sup>&reg;</sup>"));
		$this.html($this.html().replace(/&trade;|™/gi, "<sup>&trade;</sup>"));
		// Superscripts (French)
		$this.html($this.html().replace(/🅫/gi, "<sup>&trade;</sup>"));
		$this.html($this.html().replace(/🅪/gi, "<sup>&trade;</sup>"));
	});

	// ========================================================
	// WP TABLE BLOCK SCROLL FADES (left/right)
	// ========================================================
	const $tables = $(".wp-block-table");

	if ($tables.length) {
		$tables.each((i, el) => {
			const scrollContainer = el;

			const checkScrollPosition = () => {
				const hasHorizontalScroll =
					scrollContainer.scrollWidth - scrollContainer.clientWidth >
					1;
				const isAtStart = scrollContainer.scrollLeft <= 0;
				const isAtEnd =
					scrollContainer.scrollLeft + scrollContainer.clientWidth >=
					scrollContainer.scrollWidth - 1;

				scrollContainer.classList.toggle(
					"is-scrollable",
					hasHorizontalScroll
				);
				scrollContainer.classList.toggle("is-scroll-start", isAtStart);
				scrollContainer.classList.toggle("is-scroll-end", isAtEnd);
			};

			// Events
			scrollContainer.addEventListener("scroll", checkScrollPosition, {
				passive: true,
			});
			Globals.$window.on("resize", checkScrollPosition);

			requestAnimationFrame(checkScrollPosition);
		});
	}
	// ========================================================
	// BACK TO TOP
	// ========================================================
	const $backToTop = $(".back-to-top");

	if ($backToTop.length) {
		const toggleBackToTop = () => {
			const threshold = window.innerHeight * 0.5;
			$backToTop.toggleClass("is-visible", window.scrollY > threshold);
		};

		Globals.$window.on("scroll", toggleBackToTop);
		toggleBackToTop();

		$backToTop.on("click", (e) => {
			e.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
})(jQuery);
